import { metricVariableComponentDescription } from './components/metricVariable';
import {
	datasourceChartComponentDescription,
	DataSourceType,
	metricChartComponentDescription,
} from './components/metricChart';
import { textMetricComponentDescription } from './components/textMetric';
import { dashboardComponentDescription } from './components/dashboard';
import { datasourceGridComponentDescription } from './components/datasourceGrid';
import { datasourceVariableComponentDescription } from './components/datasourceVariable';

export const components = [
	metricVariableComponentDescription,
	textMetricComponentDescription,
	metricChartComponentDescription,
	dashboardComponentDescription,
	datasourceChartComponentDescription,
	datasourceGridComponentDescription,
	datasourceVariableComponentDescription,
];

export function getComponentDescription(element: Element) {
	const id = element.getAttribute('data-type');
	const source = element.getAttribute('data-source');
	if (source == DataSourceType.Datasource) {
		return components.find((x) => x.id == 'ceeview/datasource');
	}
	return components.find((x) => x.id == id);
}
